import {LobbyHeaderTitleDefaultBox} from "./lobby-header-title.default.box";
import {LobbyHeaderTitleSIBox} from "./lobby-header-title.si.box";
import { styledByTheme } from "../../../../themes/architecture/styled-by-theme";

export const LobbyHeaderTitleBox = styledByTheme(LobbyHeaderTitleDefaultBox)
    .forSI(LobbyHeaderTitleSIBox)
    .apply();